import { render, staticRenderFns } from "./ProviderRating.vue?vue&type=template&id=564fb987"
import script from "./ProviderRating.vue?vue&type=script&lang=js"
export * from "./ProviderRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports